import { values } from 'lodash'
import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

import { EXTRA_INGREDIENT_TYPES } from '../constants'

const extraIngredientPropType = PropTypes.shape({
  id: idPropType.isRequired,
  type: PropTypes.oneOf(values(EXTRA_INGREDIENT_TYPES)),
})

export default extraIngredientPropType
